var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 15,
    viewBox: "0 0 24 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0673 14.6021L0.38635 3.60198C-0.128783 3.07145 -0.128783 2.21134 0.38635 1.68087L1.63211 0.397882C2.14637 -0.131739 2.97983 -0.132758 3.49529 0.395617L12 9.11344L20.5047 0.395617C21.0202 -0.132758 21.8536 -0.131739 22.3679 0.397882L23.6136 1.68087C24.1288 2.21139 24.1288 3.07151 23.6136 3.60198L12.9327 14.6021C12.4176 15.1326 11.5824 15.1326 11.0673 14.6021Z",
    fill: "#1D5D9B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDark);
export default __webpack_public_path__ + "static/media/arrow-dark.e70bee2439c9a444fcd58341fd81e074.svg";
export { ForwardRef as ReactComponent };